import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FilterParamsItem, useConfigStore } from "../store/config";
import { DEFAULT_LANGUAGE, VALID_LANGUAGES } from "../constants";
import {
  AssociateMessagePayload,
  useProcessMessageStore,
} from "../store/processMessage";
// import { convertPathToModule } from "../common/utils";

interface PtAssociateSuccessMessage {
  type: "ptAssociateSuccess";
  data: {
    details: { objectId: string | string[] };
    extraData: API.ProcessAssociateRsp | API.ProcessAssociateRsp[];
  };
}

interface PtAssociateCancelMessage {
  type: "ptAssociateCancel";
  data: { details: { objectId?: string, objectBundleId?: string } };
}

interface PtInitiateCompleteMessage {
  type: "ptInitiateComplete";
  data: {
    details: { objectId: string | string[] };
    extraData: API.ProcessInitiateRsp | API.ProcessInitiateRsp[];
  };
}
interface AfterHistoryChangeMessage {
  type: "afterHistoryChange";
  data: { pathname: string; moduleName?: string };
}
type PostMessage =
  | AfterHistoryChangeMessage
  | PtAssociateSuccessMessage
  | PtAssociateCancelMessage
  | PtInitiateCompleteMessage;

interface GlobalLanguageChangeMessage {
  type: "globalLanguageChange";
  data: "en" | "jp";
}
interface GlobalFilterChangeMessage {
  type: "globalFilterChange";
  data: FilterParamsItem[];
}
type ReceiveMessageEvent = {
  data:
    | GlobalLanguageChangeMessage
    | GlobalFilterChangeMessage
    | PtAssociatePropsMessage;
};

interface PtAssociatePropsMessage {
  type: "ptAssociateProps";
  data: AssociateMessagePayload;
}

export const useUrfPostEvents = () => {
  const location = useLocation();
  const postMessage = (message: PostMessage) => {
    if (window.parent !== window) {
      const parentOrigin = new URL(document.referrer).origin;
      // console.log(document);
      // console.log(new URL(document.referrer));
      window.parent.postMessage(
        message,
        parentOrigin //"https://app.devscopes.freyafusion.com/"
      );
    }
  };

  // useEffect(() => {
  //   postMessage({
  //     type: "afterHistoryChange",
  //     data: {
  //       pathname: `${location.pathname}${location.search}`,
  //       moduleName: "",
  //     },
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [location.pathname]);
  return postMessage;
};

export const useUrfReceiveEvents = () => {
  const [updateLanguage, updateFilter] = useConfigStore((state) => [
    state.updateLanguage,
    state.updateFilter,
  ]);
  const updateProcessMessage = useProcessMessageStore(
    (state) => state.setProcessMessage
  );

  //Scenes：If the subapplication's route uses asynchronous loading and a request is made during loading.
  //Problem：Relying solely on the iframe's onLoad event may not ensure that the subapplication loads fully.
  //Solution: Put this hook in App.tsx
  const receiveMessage = (event: ReceiveMessageEvent) => {
    // need to use environment variables
    // if (event.origin !== "https://app.devsecops.freyafusion.com") return;
    switch (event.data?.type) {
      case "globalLanguageChange": {
        console.log("globalLanguageChange event.data:", event.data);
        if (VALID_LANGUAGES.includes(event.data.data)) {
          updateLanguage(event.data.data);
        } else {
          updateLanguage(DEFAULT_LANGUAGE);
        }
        break;
      }
      case "globalFilterChange": {
        console.log("globalFilterChange event.data:", event.data);
        //@ts-ignore
        updateFilter(event.data.data);
        break;
      }
      case "ptAssociateProps": {
        console.log("ptAssociateProps event.data:", event.data);
        updateProcessMessage(event.data.data);
        break;
      }
      default:
        break;
    }
  };
  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    return () => window.removeEventListener("message", receiveMessage);
  }, []);
};
